import { Component, OnInit,Input } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-permission-error-page',
    templateUrl: './permission-error-page.component.html',
    styleUrls: ['./permission-error-page.component.css']
})
export class PermissionErrorPageComponent implements OnInit {
    @Input()
    message: string;

    constructor(private route: ActivatedRoute) { }

    ngOnInit() {
        if(!this.message)
            this.message = 'לא קיימת הרשאה';
        this.initialize();
    }


    initialize() {
        this.route.params.subscribe(params => {
            if (params["message"] != null) {
                this.message = params["message"];
            }

        });
    }

}



// WEBPACK FOOTER //
// ./src/app/components/permission-error-page/permission-error-page.component.ts